export default __webpack_public_path__ + "static/media/cscTheme.a05342c8.png";